export default "__VITE_ASSET__Kuphpvnc__"